function shareProduct() {
  const productUrl = window.location.href;
  const productTitle = document.querySelector('h1')?.innerText || document.title;

  if (navigator.share) {
    navigator.share({
      title: productTitle,
      url: productUrl
    });
  } else {
    navigator.clipboard.writeText(productUrl);
    alert("Product link copied!");
  }
}
document.addEventListener("change", function (e) {
  if (!e.target.classList.contains("variant-dropdown")) return;

  const select = e.target;
  const option = select.options[select.selectedIndex];

  // Update Variant ID
  const form = select.closest(".card, .product-card, .product-item, section, div")
    ?.querySelector('form[action="/cart/add"]');

  if (form) {
    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = option.value;
  }

  // Prices
  const price = parseFloat(option.dataset.price);
  const compare = parseFloat(option.dataset.compare);

  const priceContainer = select.closest(".card, .product-card, .product-item, section, div");

  if (!priceContainer) return;

  const salePrice = priceContainer.querySelector(".price-item--sale");
  const comparePrice = priceContainer.querySelector(".compare-at-price");
  const discount = priceContainer.querySelector(".discount-percent");

  if (salePrice) {
    salePrice.textContent = "Rs. " + price.toFixed(0);
  }

  if (comparePrice) {
    if (compare > price) {
      comparePrice.textContent = "Rs. " + compare.toFixed(0);
      comparePrice.style.display = "";
    } else {
      comparePrice.style.display = "none";
    }
  }

  if (discount) {
    if (compare > price) {
      const off = Math.round(((compare - price) / compare) * 100);
      discount.textContent = off + "% OFF";
      discount.style.display = "";
    } else {
      discount.style.display = "none";
    }
  }
});